import { Grid, useMediaQuery } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { asEur } from "utility/numbers";

interface Props {
  marketValue?: number;
  pageName?: string;
}

const KeyValues = (props: Props) => {
  const { marketValue, pageName } = props;

  const { t } = useTranslation();

  const matchesMediaQuery = useMediaQuery("(min-width: 960px)");

  return (
    <Grid item style={{ maxWidth: "fit-content" }}>
      <p
        style={{
          color: "#003366",
          width: "fit-content",
          maxWidth: 220,
          fontSize: "min(max(.8em, 3vw), .9em)",
          fontFamily: "Lato light",
          margin: matchesMediaQuery ? "-12px 0 0 0" : "0 0 1em 0",
        }}
      >
        {pageName} {t("market_value_of")}:{matchesMediaQuery ? <br></br> : " "}
        <span
          style={{
            color: "#4A76A1",
            fontSize: "min(max(.8em, 4vw), 1.6em)",
          }}
        >
          {asEur(marketValue)}
        </span>
      </p>
    </Grid>
  );
};

export default React.memo(KeyValues);
